const DescriptionFactoryFields = [
  {
    label: 'Factory Name',
    name: 'factory.name',
    defaultValue: 'N/A'
  },
  {
    label: 'Factory ID',
    name: 'factory.factoryId',
    defaultValue: 'N/A'
  },
  {
    label: 'Factory Address',
    name: 'factory.address',
    defaultValue: 'N/A'
  },
  {
    label: 'Factory Location',
    name: 'factory.area',
    format: (value: any) => {
      const labels = [value?.city, value?.state, value?.country];
      return labels.filter((v) => !!v).join(', ') || 'N/A';
    },
    defaultValue: 'N/A'
  },
  {
    label: 'Contact Person',
    name: 'contactPerson',
    format: (value, record) => {
      const tValue = value || record?.factory?.contactPerson || 'N/A';
      return tValue;
    }
  },
  {
    label: 'Contact No.',
    name: 'contactPersonPhone',
    format: (value, record) => {
      const tValue =
        [record?.areaCode || '', value || ''].filter((v) => !!v).join(' ') ||
        [record?.factory?.areaCode, record?.factory?.contactNumber]
          .filter((v) => !!v)
          .join(' ') ||
        'N/A';
      return tValue;
    }
  },
  {
    label: 'Email Address',
    name: 'contactPersonEmail',
    format: (value, record) => {
      const tValue =
        value ||
        (record?.factory?.contactEmails || [])
          .map((obj) => obj.email)
          .join(',') ||
        'N/A';
      return tValue;
    }
  }
];
const DescriptionSupplierFields = [
  {
    label: 'Supplier Name',
    name: 'supplier.name',
    defaultValue: 'N/A'
  },
  {
    label: 'Supplier ID',
    name: 'supplier.supplierId',
    defaultValue: 'N/A'
  },
  {
    label: 'Supplier Address',
    name: 'supplier.address',
    format: (_, record) => {
      return record.supplier?.address || record.supplier?.address1 || record.supplier?.address2 || 'N/A';
    }
  },
  {
    label: 'Contact Person',
    name: 'contactPerson',
    defaultValue: 'N/A'
  },
  {
    label: 'Contact No',
    name: 'contactPersonPhone',
    defaultValue: 'N/A',
    format: (value, record) => {
      const tValue =
        [record?.areaCode, value].filter((v) => !!v).join(' ') ||
        [record?.factory?.areaCode, record?.factory?.contactNumber]
          .filter((v) => !!v)
          .join(' ') || record.supplier?.phoneNumber ||
        'N/A';
      return tValue;
    }
  },
  {
    label: 'Email Address',
    name: 'contactPersonEmail',
    format: (value, record) => {
      return value || record.supplier?.email || 'N/A';
    }
  }
  // {
  //   label: 'Country/City',
  //   name: 'country',
  //   defaultValue: 'N/A'
  // }
];
const DescriptionBuyerFields = [
  {
    label: 'Name',
    name: 'productProfile.name',
    defaultValue: 'N/A'
  },
  {
    label: 'Address',
    name: 'address2',
    defaultValue: 'N/A'
  },
  {
    label: 'Country/City',
    name: 'country',
    defaultValue: 'N/A'
  },
  {
    label: 'Contact Person',
    name: 'contactPerson',
    defaultValue: 'N/A'
  }
];

export const DescriptionFields = {
  factory: DescriptionFactoryFields,
  supplier: DescriptionSupplierFields,
  product: DescriptionBuyerFields
};
